import { CalendarEvent, Goal } from '@griply/types';
import { format } from 'date-fns';

export const getGoalsCalendarEvents = (goals: Goal[]): CalendarEvent[] =>
  goals.reduce<CalendarEvent[]>((acc, goal) => {
    if (!goal.deadline) {
      return acc;
    }

    const dateStr = format(goal.deadline, 'yyyy-MM-dd');

    acc.push({
      id: `goal-${goal.id}`,
      title: goal.name,
      start: { date: dateStr },
      end: { date: dateStr },
      allDay: true,
      date: goal.deadline,
      goalId: goal.id,
      isDeadline: true,
      completed: !!goal.completedAt,
    });

    return acc;
  }, []);
